import { render, staticRenderFns } from "./CommonSysSettingConfigList.vue?vue&type=template&id=006c79a0&scoped=true&"
import script from "./CommonSysSettingConfigList.vue?vue&type=script&lang=js&"
export * from "./CommonSysSettingConfigList.vue?vue&type=script&lang=js&"
import style0 from "./CommonSysSettingConfigList.vue?vue&type=style&index=0&id=006c79a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "006c79a0",
  null
  
)

export default component.exports